import { useState } from 'react';
import { useSelector } from 'react-redux';
import { importCredencialesRdp } from '../../helpers/api_helper';

const useImportCredencialesRdp = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const importExcel = async (file) => {
        setLoading(true);
        setError(null);
        setResult(null);

        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await importCredencialesRdp(tenantId, formData);
            setResult(response);
            return response;
        } catch (err) {
            const errorMessage = `Failed to import Credenciales RDP: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const reset = () => {
        setLoading(false);
        setError(null);
        setResult(null);
    };

    return { importExcel, loading, error, result, reset };
};

export default useImportCredencialesRdp;
